var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomHeyNic = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "yjunpt272a",
    cx: 13.518,
    cy: 13.164,
    rx: 13.518,
    ry: 13.164
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "7gan1pzhvc",
    cx: 14.538,
    cy: 14.157,
    rx: 14.538,
    ry: 14.157
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.899 1.504)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#161C45",
    fillRule: "nonzero",
    cx: 14.28,
    cy: 13.679,
    rx: 13.616,
    ry: 13.287
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#687ABC",
    fillRule: "nonzero",
    cx: 13.533,
    cy: 13.121,
    rx: 13.533,
    ry: 13.121
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#354177",
    fillRule: "nonzero",
    cx: 13.848,
    cy: 13.717,
    rx: 13.389,
    ry: 13.122
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.19 .31)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m626kg1r3b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yjunpt272a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m626kg1r3b)",
    fill: "#687ABC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.64 16.884-1.247-1.196 17.211-17.33 1.247 1.196zM3.568 22.974-.18 18.693 19.862-1.489l3.748 4.282zM5.255 25.568 3.7 24.075l20.582-20.69 1.555 1.493zM9.643 28.707l-2.795-2.684L27.43 5.333l2.795 2.684z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.713 22.746c-3.516-1.768-5.921-5.349-5.921-9.478 0-5.883 4.881-10.653 10.903-10.653 2.974 0 5.67 1.164 7.637 3.05",
    fill: "#161C45",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.332 5.665c2.016 1.933 3.266 4.625 3.266 7.603 0 5.883-4.881 10.652-10.903 10.652-1.795 0-3.489-.423-4.982-1.174",
    fill: "#8498CD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.189 4.628a9.746 9.746 0 0 0-2.207-1.087c-2.337-.816-4.345-.568-5.15-.46-2.367.32-3.97 1.272-4.285 1.463-1.697 1.033-2.621 2.272-3.16 3.009-.545.747-1.432 1.989-1.86 3.845-.45 1.954-.145 3.52.043 4.43.247 1.194.653 3.159 2.337 4.93a8.831 8.831 0 0 0 3.376 2.215c.835.3 1.544.405 2.207.502.75.11 1.982.291 3.375.125 2.416-.287 4.095-1.472 4.89-2.047a11.294 11.294 0 0 0 3.03-3.26 10.609 10.609 0 0 0 1.471-4.179c.119-.965.219-2.927-.692-5.14-.354-.86-1.217-2.88-3.376-4.346z",
    fill: "#283466",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.011 7.243)",
    fill: "#161C45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Black, Roboto",
    fontSize: 11.254,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "3")), /*#__PURE__*/React.createElement("rect", {
    x: 6.666,
    y: 2.401,
    width: 8.375,
    height: 1.893,
    rx: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.298,
    y: 5.178,
    width: 8.375,
    height: 1.893,
    rx: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.69,
    y: 8.049,
    width: 8.375,
    height: 1.893,
    rx: 0.93
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.662 6.87)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#687ABC",
    fontFamily: "Roboto-Black, Roboto",
    fontSize: 11.254,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "3")), /*#__PURE__*/React.createElement("path", {
    d: "M12.161 2.401h1.95a.93.93 0 0 1 .93.93v.033a.93.93 0 0 1-.93.93h-3.8",
    fill: "#687ABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.161 2.401H7.596a.93.93 0 0 0-.93.93v.033c0 .514.417.93.93.93h2.715l1.85-1.893z",
    fill: "#687ABC"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#687ABC",
    x: 8.299,
    y: 5.177,
    width: 8.375,
    height: 1.893,
    rx: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#687ABC",
    x: 6.69,
    y: 8.048,
    width: 8.375,
    height: 1.893,
    rx: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.142 4.49 2.12-2.169c-.015 0-.038 0-.067-.002-.037 0-.231-.005-.318-.004-.218 0-.4.032-.484.046a3.07 3.07 0 0 0-.694.208 2.474 2.474 0 0 0-.679.434c-.17.156-.272.3-.305.348a1.96 1.96 0 0 0-.196.357 2.058 2.058 0 0 0-.149.783h.772z",
    fill: "#687ABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.262 2.321a3.897 3.897 0 0 1 .833.141l-1.266 1.3a.424.424 0 0 0-.16.046c-.064.027-.101.043-.15.072a.905.905 0 0 0-.157.125c-.014.014-.034.034-.057.062a.646.646 0 0 0-.15.357.759.759 0 0 0-.001.03l-.037.037h-.975l2.12-2.17zM4.496 10.243l.011-.012 1.2-1.23-.005.016c-.236.64-.782.994-.948 1.093a2.367 2.367 0 0 1-.247.127l-.011.006zM13.419 2.403H12.16l-1.85 1.891h1.246s1.814-1.939 1.862-1.891zM8.318 6.33l.1.243M8.318 6.33l1.128-1.15-1.128 1.15zM8.318 6.33a.935.935 0 0 0 .46.619c.048.028.09.047.12.06l1.793-1.83H9.446L8.318 6.33zM13.731 5.178l-1.852 1.89h2.046l1.86-1.88zM6.717 9.224l1.166-1.172-.233-.003a.972.972 0 0 0-.502.123.913.913 0 0 0-.415.522s-.059.185-.038.404c.005.054.015.107.015.107l.007.032 1.166-1.185M9.066 9.941l1.859-1.893h2.044L11.107 9.95z",
    fill: "#485793"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.364 24.77c-.057-1.237-.358-2.088-.934-2.655-.588-.58-1.465-.871-2.748-.907 1.27-.085 2.146-.406 2.735-.996.59-.59.9-1.458.964-2.71.058 1.237.359 2.088.934 2.655.588.58 1.466.871 2.749.907-1.27.085-2.147.406-2.736.996-.59.59-.9 1.458-.964 2.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.381 17.692c.08 1.138.38 1.933.927 2.473.32.317.723.544 1.232.695.383.114.822.182 1.33.208-1.169.104-1.989.422-2.55.984-.56.562-.87 1.375-.955 2.528-.08-1.138-.38-1.933-.927-2.473-.32-.316-.723-.544-1.232-.694a5.666 5.666 0 0 0-1.331-.208c1.17-.104 1.99-.423 2.55-.985.562-.562.871-1.374.956-2.527m.002-.677c-.007 2.958-1.19 4.143-4.194 4.202.073-.002.145-.002.216-.002 2.844 0 3.965 1.154 3.958 4.04.007-2.958 1.19-4.143 4.194-4.202l-.216.002c-2.844 0-3.965-1.154-3.958-4.04z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.385 8.606c-.055-1.124-.33-1.9-.856-2.418-.537-.53-1.336-.796-2.503-.83 1.155-.08 1.954-.375 2.491-.914.538-.539.823-1.33.884-2.468.055 1.125.331 1.9.856 2.418.537.53 1.337.796 2.503.831-1.155.08-1.953.374-2.491.913s-.823 1.33-.884 2.468z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 2.158c.076 1.03.35 1.752.85 2.244.294.29.664.5 1.13.638.346.102.74.165 1.196.189-1.06.098-1.804.39-2.315.902-.511.511-.795 1.25-.875 2.294-.075-1.03-.35-1.753-.849-2.244-.294-.29-.664-.5-1.13-.638a5.169 5.169 0 0 0-1.197-.19c1.06-.097 1.805-.39 2.316-.9.51-.512.794-1.25.875-2.295m.001-.647C6.396 4.225 5.31 5.312 2.554 5.366l.199-.002c2.61 0 3.638 1.06 3.631 3.707.007-2.714 1.092-3.8 3.848-3.855a9.905 9.905 0 0 1-.198.002c-2.61 0-3.638-1.059-3.632-3.706z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#161C45",
    fillRule: "nonzero",
    cx: 15.357,
    cy: 14.711,
    rx: 14.643,
    ry: 14.289
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#687ABC",
    fillRule: "nonzero",
    cx: 14.554,
    cy: 14.11,
    rx: 14.554,
    ry: 14.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#354177",
    fillRule: "nonzero",
    cx: 14.893,
    cy: 14.751,
    rx: 14.399,
    ry: 14.112
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.205 .334)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uujnlsz91d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7gan1pzhvc"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#uujnlsz91d)",
    fill: "#687ABC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.69 18.157-.653 16.87 17.856-1.766 19.198-.48zM3.837 24.707l-4.031-4.604L21.361-1.601l4.03 4.604zM5.651 27.496l-1.672-1.605 22.134-22.25 1.672 1.605zM10.37 30.872l-3.005-2.886 22.134-22.25 3.006 2.886z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.37 24.461c-3.781-1.9-6.368-5.751-6.368-10.192 0-6.327 5.25-11.456 11.726-11.456a11.83 11.83 0 0 1 8.213 3.28",
    fill: "#161C45",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.94 6.092c2.17 2.08 3.514 4.974 3.514 8.177 0 6.327-5.25 11.456-11.726 11.456-1.93 0-3.752-.456-5.358-1.264",
    fill: "#8498CD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.711 4.977a10.48 10.48 0 0 0-2.373-1.168c-2.513-.878-4.673-.612-5.538-.495-2.546.344-4.27 1.368-4.608 1.573-1.825 1.11-2.819 2.444-3.397 3.236-.587.804-1.542 2.139-2.002 4.134-.485 2.102-.155 3.786.047 4.764.265 1.285.702 3.397 2.513 5.303a9.498 9.498 0 0 0 3.63 2.382c.898.323 1.661.435 2.374.54.806.118 2.131.313 3.63.134 2.598-.309 4.403-1.583 5.259-2.202a12.144 12.144 0 0 0 3.258-3.505 11.42 11.42 0 0 0 1.582-4.494 11.045 11.045 0 0 0-.744-5.528c-.38-.925-1.309-3.097-3.63-4.674z",
    fill: "#283466",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.465 7.777)",
    fill: "#161C45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Black, Roboto",
    fontSize: 12.102,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "3")), /*#__PURE__*/React.createElement("rect", {
    x: 7.169,
    y: 2.595,
    width: 9.007,
    height: 2.036,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.925,
    y: 5.58,
    width: 9.007,
    height: 2.036,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.194,
    y: 8.668,
    width: 9.007,
    height: 2.036,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.089 7.376)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Roboto-Black, Roboto",
    fontSize: 12.102,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "3")), /*#__PURE__*/React.createElement("path", {
    d: "M13.078 2.595h2.098a1 1 0 0 1 1 1v.035a1 1 0 0 1-1 1H11.09",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.078 2.595H8.17a1 1 0 0 0-1 1v.035a1 1 0 0 0 1 1h2.92l1.99-2.035z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 8.925,
    y: 5.58,
    width: 9.007,
    height: 2.036,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 7.194,
    y: 8.668,
    width: 9.007,
    height: 2.036,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.228 4.842 2.28-2.334-.072-.001c-.04-.001-.25-.005-.342-.005-.235 0-.431.034-.52.05a3.262 3.262 0 0 0-.747.223 2.676 2.676 0 0 0-.73.467 2.28 2.28 0 0 0-.328.374C.647 3.793.58 3.946.56 4a2.217 2.217 0 0 0-.16.842h.83-.001z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.508 2.508a4.023 4.023 0 0 1 .896.152L3.043 4.058a2.432 2.432 0 0 1-.02.005l-.064.013a.466.466 0 0 0-.09.031c-.068.03-.108.046-.16.078a.968.968 0 0 0-.23.201.684.684 0 0 0-.162.415l-.04.04h-1.05l2.28-2.333h.001zM4.835 11.028l.013-.013 1.29-1.322-.006.016c-.254.69-.84 1.069-1.02 1.176a2.511 2.511 0 0 1-.265.137l-.012.006zM14.43 2.597h-1.352l-1.99 2.034h1.34s1.951-2.086 2.003-2.034zM8.945 6.82l.1.261M8.945 6.82l1.213-1.238L8.945 6.82zM8.945 6.82a1.01 1.01 0 0 0 .495.665c.051.03.097.051.129.065l1.928-1.967h-1.339L8.945 6.82zM14.767 5.581l-1.992 2.032 2.2.001 2-2.023zM7.223 9.932l1.254-1.26-.25-.004a1.028 1.028 0 0 0-.54.131.983.983 0 0 0-.447.563s-.062.198-.04.434c.005.058.016.115.016.115l.007.035 1.254-1.275M9.75 10.704l1.999-2.036h2.198l-2.002 2.045z",
    fill: "#485793"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.664 27.24c.008-3.72-1.472-5.152-5.25-5.078 3.778-.074 5.266-1.564 5.274-5.284-.008 3.72 1.472 5.152 5.25 5.078-3.778.074-5.266 1.565-5.274 5.284zM7.218 8.856c-.338-2.037-1.28-2.69-3.342-2.312 2.061-.377 2.739-1.326 2.4-3.363.339 2.037 1.281 2.69 3.343 2.311-2.062.378-2.74 1.327-2.401 3.364z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomHeyNic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-hey-nic.0ef873f8ba4e1853dc2eb14068e0009b.svg";